import { useWindowDimensions } from '~shared/hooks/useWindowDimensions';

/**
 * A utility to calculate the max width of the QR code.
 * **ONLY if the QR code is in a container that fills up the whole window!!**
 * @param width the max width of the QR code
 */
export function useQrCodeMaxWidth(width: number) {
  const windowDimensions = useWindowDimensions();
  const qrCodeWidth = Math.min(windowDimensions?.width * 0.8, width);
  return qrCodeWidth;
}
